import directives from '../directives'

const registeredDirectives = Object.values(directives)
const directiveSignatures = registeredDirectives.map(directive => directive.signature)

export function walkDOM(element, callback) {

    const filter = {
        acceptNode: node => {

            // Skip script tags with an arbor attribute and their next sibling
            if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SCRIPT' && node.hasAttribute('arbor')) {

                // Skip this node and mark the next sibling to be skipped
                if (node.nextElementSibling) {
                    node.nextElementSibling._skipNode = true
                }

                // Skip this node and all its children
                return NodeFilter.FILTER_REJECT

            }

            // Skip nodes marked to be skipped
            if (node._skipNode) {

                delete node._skipNode

                return NodeFilter.FILTER_REJECT

            }

            // Check for text nodes with ${} templates
            if (node.nodeType === Node.TEXT_NODE) {
                return node.textContent.includes('${') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
            }

            // Check for element nodes with qv-on: attributes
            if (node.nodeType === Node.ELEMENT_NODE) {

                /*
                 * Do not descend into child nodes of qv-for elements as these are handled by qv-for
                 * if (node.parentNode && node.parentNode.hasAttribute && (node.parentNode.hasAttribute('qv-for') || node.parentNode.hasAttribute('qv-if'))) {
                 *     return NodeFilter.FILTER_SKIP
                 * }
                 */

                return node.hasAttribute &&
                    Array.from(node.attributes).some(
                        attribute => matchesDirectiveSignature(attribute.name),
                    )
                    ? NodeFilter.FILTER_ACCEPT
                    : NodeFilter.FILTER_SKIP

            }

            return NodeFilter.FILTER_SKIP

        },
    }

    const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, // Show both text and element nodes
        filter,
    )

    let currentNode = walker.currentNode

    while (currentNode) {

        const node = currentNode

        callback(node)

        if (node.attributes && (node.hasAttribute('qv-for') || node.hasAttribute('qv-if') || node.hasAttribute('qv-ignore'))) {

            // Manually skip the subtree
            currentNode = skipChildren(walker, node)

        } else {

            // Move to the next node normally
            currentNode = walker.nextNode()

        }

    }

}

function skipChildren(walker, node) {

    // Skip all children of this node
    let next = node

    do {

        if (next === walker.root) {
            return null
        }

        if (next.nextElementSibling) {

            walker.currentNode = next.nextElementSibling

            return walker.currentNode

        }

        next = next.parentElement

    } while (next)

    return null

}

function matchesDirectiveSignature(attributeName) {
    return directiveSignatures.some(signature => attributeName.startsWith(signature))
}
